import { useNavigate } from 'react-router-dom';

import { useAdminSosListContainerQuery } from '@/graphql';
import { viewFactory } from '@/utils';

import { AdminSosListView } from './AdminSosListView';

const AdminSosListContainer = () => {
    const navigate = useNavigate();
    const { data, loading, refetch, error } = useAdminSosListContainerQuery();
    return viewFactory(
        AdminSosListView,
        { data, loading, refetch, error },
        {
            onBack: () => navigate('/'),
        }
    );
};

export { AdminSosListContainer };
